export default {
  form: async (attr, related_entity, data) => {
    // deconstruct the data object
    let { details_types, selected_categories, units = [] } = data;

    var type = {};
    var showInWeb = {};
    var publicationName = {};
    var measuringUnit = {};
    var main_specifications = {};
    var showcase_specification = {};
    if (attr.current.parent_id == null) {
      if (attr.current.children)
        type = {
          value: attr.current.type_id,
          name: "type_id",
          label: "Tipi",
          type: "select-field",
          disabled: true,
          disabled_text: attr.current.type_id,
          options: attr.attribute_types,
          style: "min-width: 30%",
        };
      else
        type = {
          value: attr.current.type_id,
          name: "type_id",
          label: "Tipi",
          type: "select-field",
          options: attr.attribute_types,
          style: "min-width: 30%",
        };

      if (related_entity == "products") {
        showInWeb = {
          value: attr.current.show_web,
          name: "show_web",
          label: "Shfaq ne web",
          style: "min-width: 28%",
          type: "checkbox-field",
        };
        publicationName = {
          value: attr.current.publication_name || "",
          name: "publication_name",
          label: "Emri per publikim",
          type: "text-field",
          style: "min-width: 30%",
        };
        measuringUnit = {
          value: attr.current.measuring_unit,
          name: "measuring_unit",
          label: "Njesi matse",
          type: "select-field",
          options: units,
          style: "min-width: 30%",
        };
        main_specifications = {
          value: attr.current.show_main_specification,
          name: "show_main_specification",
          label: "Shfaq tek statistikat kryesore",
          style: "min-width: 28%",
          type: "checkbox-field",
        };
        showcase_specification = {
          value: attr.current.show_showcase_specification,
          name: "show_showcase_specification",
          label: "Shfaq ne specifika vetrine",
          style: "min-width: 28%",
          type: "checkbox-field",
        };
      }
    } else {
      type = {
        // value: attr.current.type_id,
        // name: 'type_id',
        // label: 'Tipi',
        // type: 'select-field',
        // disabled: true,
        // disabled_text: attr.current.type_id,
        // options: attr.attribute_types
      };
    }

    return {
      name: "<span class='mr-1'>Modifiko</span> <b>" + attr.current.name + "</b>",
      submit: {
        label: "Modifiko",
        action: "submitCreateAttribute",
      },
      delete: {
        guid: attr.current.guid,
        model: "Attribute",
        api: "attribute/delete/" + related_entity,
        text: "Jeni te sigurte qe doni ta fshini kete atribut?",
        permission:
          related_entity === "products"
            ? "product.can_delete_product_attributes"
            : related_entity === "customers"
              ? "customer.can_delete_customer_attributes"
              : null,
      },
      fields: [
        [
          {
            value: attr.current.code,
            name: "code",
            label: "Kodi",
            type: "text-field",
            unique: {
              model: "attribute",
              field: "code",
              where: [
                {
                  column: "related_entity",
                  condition: "=",
                  value: related_entity,
                },
                {
                  column: "guid",
                  condition: "!=",
                  value: attr.guid,
                },
              ],
            },
            left_icon: "fa-solid fa-hashtag",
            style: "min-width: 45%",
            required: true,
          },
          {
            value: attr.current.name,
            name: "name",
            label: "Emri",
            type: "text-field",
            style: "min-width: 45%",
            required: true,
            required_text: "Kjo fushe eshte e detyrueshme",
          },
          {
            value: attr.current.active,
            name: "active",
            label: "Aktiv",
            type: "checkbox-field",
            style: "min-width: 2%",
            unique: true,
          },
        ],
        // Wrap the description field in its own array (row)
        {
          value: attr.current.description,
          name: "description",
          label: "Pershkrimi",
          type: "textarea-field",
        },
        [
          // Wrap the new product category field in its own array (row)
          {
            name: "category_id",
            label: "Kategoria e produktit",
            type: "tree-select",
            style: "min-width: 100%",
            options: details_types,
            mode: "multiple",
            selected_options: selected_categories,
            is_standalone_multiple: 1,
            // is_multiple: 1,
          },
        ],

        // Row 1: Type, publication name, measuring unit
        [type, publicationName, measuringUnit],
        // Row 2: Checkboxes (show in web, main stats, showcase)
        [showInWeb, main_specifications, showcase_specification],
      ],
    };
  },
};
